// src/hooks/useBackdropClose.js
//
// ✅ 모달 "배경(오버레이) 클릭으로 닫기"의 단일 구현.
//
// ⚠️ 오버레이에 onClick을 직접 물리면 안 된다. click 이벤트의 target은 mousedown과
//    mouseup의 "공통 조상"이라, 모달 안에서 텍스트를 드래그하다 모달 밖에서 손을 떼면
//    target이 오버레이가 되어 "배경 클릭"으로 오판되고 모달이 닫힌다 — 입력 중이던
//    값이 그대로 날아간다. 실제로 견적서 마법사에서 신고된 버그다.
//
//    같은 이유로 "오버레이 onClick={close} + 내부 onClick={e => e.stopPropagation()}"
//    조합도 안전하지 않다. 그 경우 click의 target 자체가 오버레이라 내부 핸들러는
//    아예 실행되지 않고 오버레이 쪽이 그대로 발동한다.
//
// 그래서 "누른 곳도 오버레이, 뗀 곳도 오버레이"일 때만 닫는다.
//
// 사용법 — 반환값을 오버레이 div에 그대로 펼친다:
//
//   const backdrop = useBackdropClose(onClose);
//   <div style={overlayStyle} {...backdrop}>
//     <div style={panelStyle}>…</div>   ← 내부에 stopPropagation을 달 필요가 없다
//   </div>
//
// ESC 키·X 버튼 닫기는 이 훅의 범위가 아니다(각 모달이 하던 대로 둔다).
import { useCallback, useRef } from "react";

export default function useBackdropClose(onClose) {
  // 이번 드래그가 오버레이에서 시작했는가. ref인 이유는 값이 바뀌어도 다시 그릴
  // 필요가 없고, mousedown→mouseup 사이에 리렌더가 끼어도 유지돼야 하기 때문이다.
  const downOnBackdrop = useRef(false);

  const onMouseDown = useCallback((e) => {
    downOnBackdrop.current = e.target === e.currentTarget;
  }, []);

  const onMouseUp = useCallback((e) => {
    const shouldClose = downOnBackdrop.current && e.target === e.currentTarget;
    downOnBackdrop.current = false;   // 어느 경우든 플래그는 여기서 정리한다
    if (shouldClose && onClose) onClose();
  }, [onClose]);

  return { onMouseDown, onMouseUp };
}
